/** @jsxImportSource @emotion/react */
import { FormControlLabel, Checkbox as MuiCheckbox, CheckboxProps, FormControlLabelProps } from '@mui/material'
import { FC } from 'react'
import * as classes from './styles'

export type Props = {
  checkboxProps?: CheckboxProps
} & Omit<FormControlLabelProps, 'control'>

export const Checkbox: FC<Props> = ({ checkboxProps, ...rest }) => (
  <FormControlLabel control={<MuiCheckbox {...checkboxProps} />} {...rest} css={classes.checkbox} />
)
